import { render, staticRenderFns } from "./CardRendimento.vue?vue&type=template&id=2644c7f2&scoped=true&"
import script from "./CardRendimento.vue?vue&type=script&lang=js&"
export * from "./CardRendimento.vue?vue&type=script&lang=js&"
import style0 from "./CardRendimento.vue?vue&type=style&index=0&id=2644c7f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2644c7f2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardActions,VCardText,VIcon,VSpacer})
